import React from 'react';
import {Link} from 'react-router';
import {Dialog} from "@blueprintjs/core";
import { Reception } from 'api';
import { connect } from 'react-redux';
import {DropDown, TextArea} from 'components/tt-forms/common';
import {validatable} from 'components/utils';
import {msg} from "constants/message";
import {Toastr} from 'modules/toastr';

class XuLyYeuCau extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      trangThaiList: [],
      loading: false,
      trangThai: '',
      lyDo: ''
    }
  }

  componentDidMount() {
    this.getTrangThai();
  }

  closeDialog() {
    this.props.onClose();
  }

  getTrangThai() {
    if (this.props.trangThaiList) {
      let trangThaiList = this.props.trangThaiList;
      trangThaiList.map((item, index) => {
        if ((this.props.data.trangThaiYeuCauGapLanhDao == 'CHO_XIN_Y_KIEN' || this.props.data.trangThaiYeuCauGapLanhDao == 'KHONG_DONG_Y') && item.giaTri == 'DONG_Y') {
          trangThaiList.splice(index, 1);
        }
      });
      this.setState({
        trangThaiList: trangThaiList
      });
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['YeuCau'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  handleChangeData(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open) {
      this.getTrangThai();
    }
  }

  xuLyYeuCau() {
    let state = this.state;
    if (this.validateSubmitForm()) {
      state.loading = true;
      let params = {
        trangThaiYeuCauGapLanhDao: this.state.trangThai,
        lyDoThayDoiTTYeuCauGapLanhDao: this.state.lyDo
      }
      Reception.actions.updateXuLyYeuCau.request({id: this.props.data.donId}, params).then(res => {
        if (res.data) {
          state.loading = false;
          Toastr(msg.xuLyYeuCau, 'success');
          this.closeDialog();
          this.props.onSuccess();
        }
      });
    }
    this.setState(state);
    this.props.dispatch({
      type: 'REFRESH_MENU',
      value: true
    });
  }

  render() {
    return (
      <Dialog
        isOpen={this.props.open}
        onClose={this.closeDialog.bind(this)}
        title={'Xác nhận'}
        className="panel-popup category">
        <div className="pt-dialog-body">
          <DropDown label="Ý kiến lãnh đạo"
            selectedValue={this.state.trangThai}
            className='input-default'
            options={this.state.trangThaiList}
            keyName='giaTri' valueName='ten'
            require={true}
            bindValidator={this}
            channel="YeuCau"
            onChange={ this.handleChangeData.bind(this, 'trangThai') }
            placeholder />
          <TextArea label="Lý do" className="pl0 pr0" rows={5} placeholder="Nhập..." bindValidator={this}
            channel="YeuCau" maxLength={1000} value={this.state.lyDo} onChange={this.handleChangeData.bind(this, 'lyDo')} require={true} name="textareaLydo"/>
          { this.state.trangThai == 'KHONG_DONG_Y' && this.props.data.trangThaiYeuCauGapLanhDao == 'DONG_Y' ?
              <div className="pt-form-helper-text pt0">Chọn "Không đồng ý", đơn này sẽ bị hủy khỏi danh sách tiếp định kỳ của lãnh đạo</div>
            : ''
          }
          { this.state.trangThai == 'CHO_XIN_Y_KIEN' && this.props.data.trangThaiYeuCauGapLanhDao == 'DONG_Y' ?
              <div className="pt-form-helper-text pt0">Chọn "Chờ xin ý kiến", đơn này sẽ bị hủy khỏi danh sách tiếp định kỳ của lãnh đạo</div>
            : ''
          }
        </div>
        <div className="pt-dialog-footer">
          <Link onClick={this.closeDialog.bind(this)} className="btn-action btn-close" >
            <span>Không</span>
          </Link>
          <Link className={this.state.loading ? "btn-action btn-save btn-loading-inline" : "btn-action btn-save"} onClick={this.xuLyYeuCau.bind(this)}>
            <span>Đồng ý</span>
          </Link>
        </div>
      </Dialog>
    );
  }
}

export default connect()(validatable(XuLyYeuCau));



// WEBPACK FOOTER //
// ./src/components/modules/dialog/XuLyYeuCau.jsx